import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import http from "../http-common";

const useBusinessPlan = (uuid) => {
  const [businessPlan, setBusinessPlan] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const result = await http.get(`/business-plan/uuid/${uuid}`);
        setBusinessPlan(result.data);
      } catch (error) {
        toast.error(error.response?.data.message);
      } finally {
        setIsLoading(false);
      }
    };

    if (uuid) {
      fetchData();
    }
  }, [uuid]);

  return { businessPlan, isLoading };
};

export default useBusinessPlan;
